module.exports = __webpack_public_path__ + "img/banner_knowledge.09589755.png";